export const generateYearExperienceOpts = () => {
	const expArr = Array.from(
	  { length: 20 }, 
	  (_, i) => {
		return {
		  label: i+1, 
		  value: i+1
		}
	  }
	)
	expArr.push({
		value: '20+',
		label: '20+',
	}, {
		value: '30+',
		label: '30+',
	}, {
		value: '40+',
		label: '40+',
	})
	return expArr;
};